export default __webpack_public_path__ + "static/media/Wayne Sun.b602755c.png";